<template>
  <div id="app">
    <Header />
    <main>
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', sans-serif;
  line-height: 1.6;
  color: #333;
  overflow-x: hidden;
}

html {
  overflow-x: hidden;
}

/* 确保所有图片和媒体元素不会超出容器 */
img,
video,
iframe {
  max-width: 100%;
  height: auto;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

/* 通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-title {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: #333;
}

.btn {
  display: inline-block;
  padding: 1rem 2rem;
  background: #64B800;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: bold;
  transition: background 0.3s ease;
}

.btn:hover {
  background: #c7380c;
}

/* 通用按钮样式 */
.btn-primary {
  background: #64B800;
  color: white;
  padding: 0;
  border: none;
  font-weight: bold;
  width: 180px;
  height: 50px;
  cursor: pointer;
  margin-top: 2rem;
  transition: background 0.3s;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  line-height: 50px;
  font-size: 1rem;
  border-radius: 4px;
}

.btn-primary:hover {
  background: #64B800;
}

.btn-primary-1 {
  background: #64B800;
  color: white;
  padding: 0;
  border: none;
  font-weight: bold;
  width: 11.25rem;
  height: 3.12rem;
  line-height: 3.12rem;
  text-align: center;
  cursor: pointer;
  margin-top: 1rem;
  transition: background 0.3s;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  text-decoration: none;
  font-size: 1rem;
  border-radius: 4px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .container {
    padding: 0 1rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
}
</style>
